/**
 * @owner @Appboy/billing
 */

export const bannersConsumption = "/analytics_dashboard/:app_group_id/banners_credit_consumption_detail_data";
